const Intro = () => {
    return (
        <div className="max-w-full mx-auto p-6 lg:px-12 lg:pb-4 text-zinc-800 dark:text-zinc-200">
            <div className="flex flex-col space-y-4">
                <div className="text-3xl font-base text-purple-600 dark:text-purple-400 font-bold">Jibu</div>
                <div className="font-roboto font-light text-zinc-500 dark:text-zinc-400">Swahili [/ʄibu/] </div>
                <p className="font-light text-zinc-600 dark:text-zinc-400">Translation: an answer or solution to a question.</p>
                <div className="lg:text-lg font-light pt-6 text-zinc-700 dark:text-zinc-300 space-y-6 leading-relaxed max-w-4xl">
                    <p>
                        Jibu Labs was founded on a simple premise: AI is only as powerful as the engineering and business strategy behind it.
                    </p>
                    <p>
                        We are not just theorists. Our leadership brings a rare combination of top-tier business acumen and world-class technical expertise. As a Google Developer Expert (GDE) for Android and an active voice on international tech stages, we know what it takes to build and ship production-ready software.
                    </p>
                    <p>
                        Backed by executive-level business strategy from Cornell's Executive MBA program and years of engineering management experience leading mobile platform design at major financial institutions, we don't just recommend AI solutions; we architect them to drive measurable business growth, operational efficiency, and market dominance.
                    </p>
                    <p>
                        Whether you are an enterprise looking to overhaul your developer workflows, or a startup integrating multimodal AI into a cross-platform mobile app, Jibu Labs provides the technical roadmap and the leadership to get it done.
                    </p>
                </div>
            </div>
        </div>
    )
}

export default Intro